// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import classnames from "classnames";
import { PrivateRoute } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
import selectors from "model/selectors";

import Page from "../Page";
import Users from "../Users";
// import Search from "containers/workflow-client/pages/Search";
// import Emission from "containers/workflow-client/pages/Emission";
// import Acquiring from "containers/workflow-client/pages/Acquiring";

// RELATIVE PATH IMPORTS

// connecting component to the redux store
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      roles: selectors.user.roles$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("admin-workflow")
export default class App extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    match: PropTypes.object,
    loggedIn: PropTypes.bool,
    sessionStatusConfirmed: PropTypes.bool,
    requestInProgress: PropTypes.bool,
  };

  render() {
    const { theme, match } = this.props;
    return (
      <div className={classnames(theme.wrapper)}>
        <Switch>
          <PrivateRoute
            auth={true}
            path={`${match.path}/:subdir?`}
            render={() => (
              <Page basePath={match.path} pageHeader={"Администрирование"}>
                <Users basePath={match.path} />
              </Page>
            )}
          />
          <PrivateRoute
            auth={true}
            path="*"
            render={() => <Redirect to={`${match.path}`} />}
          />
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Workflow/Workflow.js